/**
 * NOT USED
 */
import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import { AngularFireDatabase, AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';

import { ProfileImageUpload } from '../models/profile-image-upload';
import { Speaker } from '../models/speaker';
import { ContentsMandatory } from '../models/contents-mandatory';

@Injectable()
export class ChairpersonService {

	constructor(private db: AngularFireDatabase, private utilityService: UtilityService) { }

	getSpeakerById(eventId: string, speakerId: string): Observable<Speaker> {
		let data: AngularFireObject<Speaker> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.SPEAKER_URL + '/' + speakerId);
		return data.valueChanges();
	}

	getSpeakersList(eventId: string) {
		if (this.utilityService.isLogged()) {
			return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.SPEAKER_URL);
		}
		return null;
	}

	addSpeakerDetails(speaker: Speaker, eventID: string) {
		return this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.SPEAKER_URL).push(speaker).key;
	}

	updateSpeakerDetails(speaker: Speaker, eventID: string, speakerId: string): Promise<any> {
		
		let dbPath = Constants.EVENT_URL + '/' + eventID + Constants.SPEAKER_URL + "/" + speakerId;
		console.log("FROM_FXN",dbPath, speaker);
		return this.db.object(dbPath).set(speaker);

	}


	getSpeakerType(eventId: string): Observable<Speaker> {
		let data: AngularFireObject<Speaker> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.CATEGORY_SPEAKERS);
		return data.valueChanges();
	}

	updateSpeakerPosition(eventID, sponsorsList) {
		// TODO: This should be 1 query. Right now ther are multiple.
		for (let item of sponsorsList) {
			let key = item.$key;
			this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.SPEAKER_URL + '/' + key).update({ position: item.position });
		}
	}

	deleteSpeaker(sponsor: Speaker, eventId: string, sponsorsList) {
		if (sponsorsList.length <= 0) {
			return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.SPEAKER_URL).remove(sponsor.$key);
		} else {
			this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.SPEAKER_URL).remove(sponsor.$key);
			let i = 0;
			for (let item of sponsorsList) {
				let key = item.$key;
				var data = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.SPEAKER_URL + '/' + key).update({ position: item.position });
				i++;
				if (i == sponsorsList.length) {
					return data;
				}

			}
		}

	}


	getSingleSpeakerProfile(eventId: string, speakerId: string): Observable<Speaker> {
		let data: AngularFireObject<Speaker> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.SPEAKER_URL + "/" + speakerId);
		return data.valueChanges();
	}

	getChairpersonProfile(eventId: string): AngularFireList<string> {
		if (this.utilityService.isLogged()) {
			return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.SPEAKER_URL);
		}
		return null;
	}

	getEmailList(eventId: string): Observable<Speaker> {
		let data: AngularFireObject<Speaker> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.SPEAKER_URL);
		return data.valueChanges();
	}

	pushUpload(profileImageUpload: ProfileImageUpload, eventId: string) {
		let fileName = profileImageUpload.file.name;
		let storageRef = firebase.storage().ref();
		return storageRef.child(`${eventId + Constants.Contents_Mandatory_URL + "/" + Constants.CONTENT_M_TYPE_SPEAKERS}/${fileName}`).put(profileImageUpload.file);
	}


	addContentMandatory(contentsMandatory: ContentsMandatory): string {
		return this.db.list(Constants.EVENT_URL + '/' + contentsMandatory.eventId + Constants.Contents_Mandatory_URL)
			.push(contentsMandatory).key;
	}


	deleteFileStorage(filename: string) {
		return firebase.storage().ref();
	}

	deleteSpeakerID(event: Speaker, eventID: string) {
		let speakerId = event.$key;

		console.log(speakerId, eventID)
		return this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.SPEAKER_URL).remove(speakerId);
	}

	/** new added */
	getAllSpeakers(eventId: string,) {
    return firebase.database().ref(Constants.EVENT_URL + '/' + eventId + Constants.SPEAKER_URL).once("value");
	}

	addBulkSpeakers(speaker: any, eventID: string) {
		return this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.SPEAKER_URL).set(speaker);
	}
	
}



// WEBPACK FOOTER //
// /app/src/app/core/services/chairperson.service.ts